import {
  DropdownMenu,
  GhostIconButton,
  MenuItem,
  MenuSection,
  Text,
} from "@certn/cascadia-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { EditAPIKeyModal } from "./EditAPIKeyModal";
import { RevokeAPIKeyModal } from "./RevokeAPIKeyModal";
import { APIKeyWithNameAndID } from "./types";

interface Props {
  apiKey: APIKeyWithNameAndID;
  onItemChanged: () => void;
}
export function ActionsDropdown({ apiKey, onItemChanged }: Props) {
  const { t } = useTranslation();
  const [showRevokeModal, setShowRevokeModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  return (
    <>
      <DropdownMenu
        triggerButton={
          <GhostIconButton
            testID="api-key-listing-item-expand"
            size="small"
            icon="more_horiz"
            aria-label={t("Expand menu")}
          />
        }
        onItemAction={(menuItem) => {
          switch (menuItem) {
            case "edit-name":
              setShowEditModal(true);
              break;
            case "revoke":
              setShowRevokeModal(true);
              break;
          }
        }}
        placement="bottom right"
      >
        <MenuSection>
          <MenuItem id="edit-name" testID="api-key-listing-edit-name">
            <Text style="input/text-field">{t("Edit name")}</Text>
          </MenuItem>
          <MenuItem id="revoke" testID="api-key-listing-revoke">
            <Text style="input/text-field" color="text-danger">
              {t("Revoke")}
            </Text>
          </MenuItem>
        </MenuSection>
      </DropdownMenu>
      <RevokeAPIKeyModal
        apiKey={apiKey}
        onRevoked={onItemChanged}
        isOpen={showRevokeModal}
        onOpenChange={setShowRevokeModal}
      />
      <EditAPIKeyModal
        apiKey={apiKey}
        onSuccess={onItemChanged}
        isOpen={showEditModal}
        onOpenChange={setShowEditModal}
      />
    </>
  );
}
